'use client';
import Link from 'next/link';

export default function FooterCopyright() {
  const currentYear = new Date().getFullYear();

  return (
    <div className='mt-12 border-t border-designer-border pt-6'>
      <div className='text-center sm:flex sm:justify-between sm:text-left'>
        <p className='text-gray-500'>
          <span className='block sm:inline'>All rights reserved.</span>
          <Link
            className='inline-block text-designer-blue hover:text-white transition-colors duration-300'
            href='/terms-conditions'
            target='_blank'
          >
            Terms & Conditions
          </Link>
          {/* <span>&middot;</span>
          <Link
            className='inline-block text-designer-blue hover:text-white transition-colors duration-300'
            href='#'
          >
            Privacy Policy
          </Link> */}
        </p>
        <p className='mt-4 text-gray-500 sm:order-first sm:mt-0'>
          &copy; {currentYear} Envision
        </p>
      </div>
    </div>
  );
}
